import { render, staticRenderFns } from "./title-format-al-bronzo-cmp.vue?vue&type=template&id=6c75a1fe&scoped=true"
import script from "./title-format-al-bronzo-cmp.vue?vue&type=script&lang=js"
export * from "./title-format-al-bronzo-cmp.vue?vue&type=script&lang=js"
import style0 from "./title-format-al-bronzo-cmp.vue?vue&type=style&index=0&id=6c75a1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75a1fe",
  null
  
)

export default component.exports